import { Injectable } from '@angular/core';
import { TranslocoInterceptor } from '@ngneat/transloco';

@Injectable({ providedIn: 'root' })
export class CustomTranslocoInterceptor implements TranslocoInterceptor {
  preSaveTranslationKey(key: string, value: string, lang: string): string {
      throw new Error('Method not implemented.');
  }
  preSaveTranslation(translation: any, lang: string): any {
    // Aquí puedes manipular la traducción antes de que sea guardada
    return translation;
  }
}